type EquipmentItem = {
  code: string | number;
  quantity: string | number;
};

export const formatEquipmentString = (
  equips: EquipmentItem[] | undefined,
  t: (key: string) => string,
) => {
  if (!equips || equips.length === 0) return '';
  return equips
    .filter((item) => Number(item.quantity) > 0)
    .map((equip) => `${t(`equipment_${equip.code}`)} (${equip.quantity})`)
    .join(' / ');
};
